<template>
  <div>
    <nav class="bottom-nav">
      <router-link to="/" class="bottom-nav-item">
        <i class="material-icons-outlined mb-1">home</i>
        <p class="typography-headline-sm">Home</p>
      </router-link>
      <router-link to="/palettes" class="bottom-nav-item">
        <i class="material-icons-outlined mb-1">view_week</i>
        <p class="typography-headline-sm">Palettes</p>
      </router-link>
      <router-link to="/gradients" class="bottom-nav-item">
        <i class="material-icons-outlined mb-1">animation</i>
        <p class="typography-headline-sm">Gradients</p>
      </router-link>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'BottomNavigation',
}
</script>